/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import L from "../Lang"
import BaseCom from "../BaseCom";
import Icon from "../Icon";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import { SidebarGlobal } from "../_SidebarGlobal";
import DataTable from "../DataTable";
import { Modal } from "react-bootstrap";
import FormInput from "../FormInput";
import { qreq } from "../../shared/qrequest";
import { Pop } from "../PopModal";

class NextActions extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            item: {},
            query: {},
            loaded: false,
            loading: false,
            list: []
        };
        this.edit = this.edit.bind(this);
        this.submitEdit = this.submitEdit.bind(this);
        this.load = this.load.bind(this);
        this.delete = this.delete.bind(this);
    }

    componentDidMount() {
        SidebarGlobal.setSubNav(<><div className="btn-group">
            <button type="button" className="btn btn-primary" onClick={() => this.edit({})}><Icon icon="faPlus" /> <span className="d-none d-md-inline"><L>New Category</L></span></button>
        </div></>);
        this.load();
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    load() {
        qreq.get('/api/manage/document-category/list', j => {
            if (j.list)
                this.setState({ list: j.list });
            else
                this.alert(j.errorMessage);
        }, this.unkownErrorCallback);
    }

    edit(item) {
        this.setState({ item: { ...item }, showEdit: true });
    }

    delete(item) {
        Pop.showConfirm(<>{item.name}</>, 'Are you sure you want to delete this category?', () => {
            qreq.post('/api/manage/document-category/delete', { id: item.id }, j => {
                if (j.errorCode === 0) {
                    this.load();
                    this.success('Document Category deleted');
                }
                else {
                    this.alert(j.errorMessage);
                }
            }, this.unkownErrorCallback);
        });
    }

    submitEdit(e) {
        e?.preventDefault();
        qreq.post('/api/manage/document-category/save', { ...this.state.item }, j => {
            if (j.errorCode === 0) {
                this.setState({ showEdit: false });
                this.load();
                this.success('Document Category saved');
            }
            else {
                this.alert(j.errorMessage);
            }
        }, this.unkownErrorCallback);
    }

    render() {
        return <div className="container-fluid">
            <Modal show={this.state.showEdit} onHide={() => this.setState({ showEdit: false })}>
                <Modal.Header closeButton>
                    <Modal.Title>{this.state.item.id ? 'Edit' : 'New'} Document Category</Modal.Title>
                </Modal.Header>
                <form onSubmit={this.submitEdit}>
                    <Modal.Body>
                        <FormInput model={this.state.item} name="name" label="Category Name" type="text" required />
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="btn btn-secondary" onClick={() => this.setState({ showEdit: false })}><Icon icon="faCancel" /> <L>Cancel</L></button>
                        <button type="submit" className="btn btn-success"><Icon icon="faSave" /> <L>Save</L></button>
                    </Modal.Footer>
                </form>
            </Modal>
            <h1><L>Document Categories</L></h1>
            <DataTable columns={[
                { name: 'edit', icon: 'Pencil', valueFunc: row => <span role="button" onClick={() => this.edit(row)} className="text-primary"><Icon icon="faPencil" /></span> },
                { name: 'delete', icon: 'Trash', valueFunc: row => <span role="button" onClick={() => this.delete(row)} className="text-primary"><Icon icon="faTrash" /></span> },
                { name: 'name', title: 'Action', valueFunc: row => <span role="button" onClick={() => this.edit(row)} className="text-primary">{row.name}</span> },
            ]} data={this.state.list} />
        </div>;
    }
}

export default withParamsAndNavigate(NextActions);